export const convertZeroToEmpty = (input) => {
    let cleanInput = (input === 0 ? "" : input)
    return cleanInput
}